import React, { useState, useEffect } from 'react'
import { Box } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

import CrearCliente from './CrearCliente'
import CrearAsignacion from './CrearAsignacion'
import AdminInternalNav from '../components/AdminInternalNav'
import ConsultasNoAsignContainer from '../containers/ConsultasNoAsignContainer'
import ConsultasCerradasContainer from '../containers/ConsultasCerradasContainer'
import ClientesContainer from '../containers/ClientesContainer'
import PrincipalTableContainer from './PrincipalTableContainer'

function PrincipalAdministrador() {
  const [searchParams] = useSearchParams()
  const [showNoAsignados, setShowNoAsignados] = useState(false)
  const [showCerrados, setShowCerrados] = useState(false)
  const [showClientes, setShowClientes] = useState(false)
  const [highlightNoAsignConsultaId, setHighlightNoAsignConsultaId] = useState(null)
  const [openClienteId, setOpenClienteId] = useState(null)

  const [isFullTable, setIsFullTable] = useState(false)

  useEffect(() => {
    try {
      const openCrearHandler = () => {
        window.dispatchEvent(new Event('openCrearClienteModal'))
      }
      const openNoAsignadosHandler = (event) => {
        setHighlightNoAsignConsultaId(event?.detail?.highlightConsultaId ?? null)
        setShowCerrados(false)
        setShowClientes(false)
        setShowNoAsignados(true)
      }
      const openCerradosHandler = () => {
        setShowNoAsignados(false)
        setShowClientes(false)
        setShowCerrados(true)
      }
      const openClientesHandler = () => {
        setShowNoAsignados(false)
        setShowCerrados(false)
        setShowClientes(true)
        setOpenClienteId(null)
      }

      window.addEventListener('openCrearCliente', openCrearHandler)
      window.addEventListener('openConsultasNoAsignadas', openNoAsignadosHandler)
      window.addEventListener('openConsultasCerradas', openCerradosHandler)
      window.addEventListener('openClientesAdmin', openClientesHandler)
      return () => {
        window.removeEventListener('openCrearCliente', openCrearHandler)
        window.removeEventListener('openConsultasNoAsignadas', openNoAsignadosHandler)
        window.removeEventListener('openConsultasCerradas', openCerradosHandler)
        window.removeEventListener('openClientesAdmin', openClientesHandler)
      }
    } catch (err) {
      console.error('PrincipalAdministrador useEffect error:', err)
    }
  }, [])

  useEffect(() => {
    if (searchParams.get('admin_view') !== 'clientes') return
    const clienteId = Number(searchParams.get('cliente_id'))
    setShowNoAsignados(false)
    setShowCerrados(false)
    setShowClientes(true)
    setOpenClienteId(Number.isFinite(clienteId) && clienteId > 0 ? clienteId : null)
  }, [searchParams])

  const handleCloseFull = () => setIsFullTable(false);
  const headerActions = (
    <>
      <Box sx={{ display: 'flex', gap: 1.2, flexWrap: 'wrap' }}>
        <CrearCliente />
        <CrearAsignacion />
      </Box>
      <AdminInternalNav
        active="inicio"
        onHome={() => {}}
        onNoAsignadas={() => { setShowCerrados(false); setShowClientes(false); setShowNoAsignados(true); }}
        onCerradas={() => { setShowNoAsignados(false); setShowClientes(false); setShowCerrados(true); }}
        onClientes={() => { setShowNoAsignados(false); setShowCerrados(false); setShowClientes(true); }}
      />
    </>
  );

  // Contenedor común para las vistas secundarias para evitar scroll también allí
  const secondaryViewStyle = {
    height: 'calc(100vh - 60px)',
    overflow: 'hidden',
    boxSizing: 'border-box' // Importante
  };

  if (showNoAsignados) {
    return (
      <Box sx={secondaryViewStyle}>
        <ConsultasNoAsignContainer
          onClose={() => { setShowNoAsignados(false); handleCloseFull(); }}
          onOpenClosed={() => {
            setShowNoAsignados(false)
            setShowClientes(false)
            setShowCerrados(true)
            handleCloseFull()
          }}
          onOpenClientes={() => {
            setShowNoAsignados(false)
            setShowCerrados(false)
            setShowClientes(true)
            handleCloseFull()
          }}
          isFullScreen={isFullTable}
          onToggleFullScreen={setIsFullTable}
          highlightConsultaId={highlightNoAsignConsultaId}
          onHighlightConsumed={() => setHighlightNoAsignConsultaId(null)}
        />
      </Box>
    )
  }

  if (showCerrados) {
    return (
      <Box sx={secondaryViewStyle}>
        <ConsultasCerradasContainer
          onBackHome={() => { setShowCerrados(false); handleCloseFull(); }}
          onBackNoAsignados={() => { setShowCerrados(false); setShowClientes(false); setShowNoAsignados(true); handleCloseFull(); }}
          onOpenClientes={() => { setShowCerrados(false); setShowNoAsignados(false); setShowClientes(true); handleCloseFull(); }}
          isFullScreen={isFullTable}
          onToggleFullScreen={setIsFullTable}
        />
      </Box>
    )
  }

  if (showClientes) {
    return (
      <Box sx={secondaryViewStyle}>
        <ClientesContainer
          onBackHome={() => { setShowClientes(false); handleCloseFull(); }}
          onOpenNoAsignadas={() => { setShowClientes(false); setShowCerrados(false); setShowNoAsignados(true); handleCloseFull(); }}
          onOpenCerradas={() => { setShowClientes(false); setShowNoAsignados(false); setShowCerrados(true); handleCloseFull(); }}
          isFullScreen={isFullTable}
          onToggleFullScreen={setIsFullTable}
          initialOpenClienteId={openClienteId}
          onInitialOpenConsumed={() => setOpenClienteId(null)}
        />
      </Box>
    )
  }

  return (
    <Box sx={{
      height: 'calc(100vh - 60px)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      boxSizing: 'border-box',
      width: '100%',
      px: isFullTable ? 2 : 5,
      pt: isFullTable ? 3 : 4,
    }}>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <PrincipalTableContainer
          isFullScreen={isFullTable}
          onToggleFullScreen={setIsFullTable}
          headerActions={headerActions}
        />
      </Box>
    </Box>
  )
}
export default PrincipalAdministrador
